
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...any]]",
      function () {
        return require("private-next-pages/[[...any]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...any]]"])
      });
    }
  